import { render } from "./PaginateRefactComponent.vue?vue&type=template&id=d5d46bd8"
import script from "./PaginateRefactComponent.vue?vue&type=script&lang=js"
export * from "./PaginateRefactComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__